import { useRef } from "react";

interface ICheckboxProps {
  name: string;
  value?: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  error?: string;
  label?: string;
  required?: boolean;
}

const Checkbox = ({ name, value, onChange, disabled, className, error, label, required }: ICheckboxProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.checked = !inputRef.current.checked;
      onChange(inputRef.current.checked);
    }
  };

  return (
    <div className="controlled-checkbox-container">
      <input
        ref={inputRef}
        id={name}
        type="checkbox"
        checked={value || false}
        // onChange={handleClick)}
        disabled={disabled}
        className={`controlled-checkbox-input ${className || ""} ${error ? "error" : ""}`}
        onClick={handleClick}
      />
      <label htmlFor={name} className={`controlled-checkbox-label ${error ? "error" : ""}`} onClick={handleClick}>
        {label}
        {required && <span className="controlled-checkbox-required"> *</span>}
      </label>
      {error && <small className="controlled-checkbox-error">{error}</small>}
    </div>
  );
};

export default Checkbox;
